import { Modal as MuiModal, Box, Typography, Button, CircularProgress, useTheme } from '@mui/material';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

interface ModalDeleteProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading: boolean;
    companyName: string;
}

export function ModalDelete({ open, onClose, onConfirm, loading, companyName }: ModalDeleteProps) {
    const theme = useTheme();

    return (
        <MuiModal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-delete-title"
            aria-describedby="modal-delete-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: theme.palette.background.paper,
                    borderRadius: 3,
                    boxShadow: 24,
                    p: 4,
                    minWidth: 440,
                    maxWidth: '100vw',
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        background: theme.palette.error.light || '#FDEAEA',
                        borderRadius: '50%',
                        width: 56,
                        height: 56,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2,
                    }}
                >
                    <PersonOffOutlinedIcon sx={{ color: theme.palette.error.main, fontSize: 32 }} />
                </Box>
                <Typography
                    id="modal-delete-title"
                    sx={{
                        fontWeight: 600,
                        fontSize: 18,
                        color: theme.palette.text.primary,
                        mb: 1,
                        textAlign: 'center',
                    }}
                >
                    Confirmar exclusão
                </Typography>
                <Typography
                    id="modal-delete-description"
                    sx={{
                        color: theme.palette.text.secondary,
                        fontSize: 15,
                        textAlign: 'center',
                        mb: 3,
                    }}
                >
                    Tem certeza que deseja excluir a unidade <b>{companyName}</b>?<br />
                    Esta ação não poderá ser desfeita.
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, width: '100%', mt: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        disabled={loading}
                        sx={{
                            flex: 1,
                            bgcolor: theme.palette.background.default,
                            color: theme.palette.text.secondary,
                            borderColor: theme.palette.divider,
                            borderRadius: 2,
                            fontWeight: 600,
                            fontSize: 15,
                            boxShadow: 'none',
                            '&:hover': { bgcolor: theme.palette.action.hover, borderColor: theme.palette.divider },
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={onConfirm}
                        disabled={loading}
                        startIcon={<DeleteIcon />}
                        sx={{
                            flex: 1,
                            bgcolor: theme.palette.error.main,
                            color: theme.palette.error.contrastText,
                            borderRadius: 2,
                            fontWeight: 600,
                            fontSize: 15,
                            boxShadow: 'none',
                            '&:hover': { bgcolor: theme.palette.error.dark },
                        }}
                    >
                        {loading ? <CircularProgress size={22} color="inherit" /> : 'Deletar Unidade'}
                    </Button>
                </Box>
            </Box>
        </MuiModal>
    );
}
